'use strict';

/*
** This
*/
exports.createEl = function createEl(tagName, attributes) {
    return {
        tagName: tagName,
        attributes: attributes || {},
        addAttribute: function addAttribute(name, value) {
            this.attributes[name] = value;
            return this;
        }
    };
};

exports.createLink = function(attributes) {
    var el = exports.createEl('a', attributes);
    return el;
};

exports.createStyle = exports.createEl;
